var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { useField } from 'formik';
import { formatPhoneDefault, formatPhoneHyphen, PHONE_NUMBER_PATTERN, } from '@ally/aos-utils';
import { FormText, Box } from '@ally/metronome-ui';
import { useRegisterError } from '../utils';
export const defaultValidate = (value, required = false) => {
    if (!required && !value) {
        return undefined;
    }
    if (!value) {
        return 'Enter a phone number to continue.';
    }
    if (!PHONE_NUMBER_PATTERN.test(value)) {
        return 'Enter a valid phone number.';
    }
    return undefined;
};
const PhoneNumber = (_a) => {
    var { className, label = 'Phone', name, onBlur, onChange, required, validate } = _a, props = __rest(_a, ["className", "label", "name", "onBlur", "onChange", "required", "validate"]);
    const fallback = (value) => defaultValidate(value, required); // pass `required` prop to `defaultValidate`
    const validateFn = validate || fallback;
    const [field, meta, helpers] = useField(Object.assign(Object.assign({}, props), { name, validate: validateFn }));
    const { refValue } = useRegisterError(meta.error);
    const [displayValue, setDisplayValue] = useState(field.value !== null ? formatPhoneDefault(field.value) : '');
    /*
     * When `resetForm` is called on the parent form, it resets the phoneNumber value to the original value found in `initialValues`
     * This works fine in regards to setting the form state correctly for the phoneNumber value behind the scenes
     * The problem is that this doesn't trigger the `onCombinedChange` handler, which means the `displayValue` does not get updated to reflect the change
     * The following updates the `displayValue` when something other than the `onCombinedChange` handler changes the phoneNumber field's form state value
     */
    useEffect(() => {
        setDisplayValue(prevDisplay => formatPhoneDefault(prevDisplay) === formatPhoneDefault(field.value) // combinedOnChange event, do nothing
            ? prevDisplay
            : formatPhoneDefault(field.value));
    }, [field.value]);
    const combinedOnBlur = (e) => {
        field.onBlur(e);
        const newValue = e.target.value;
        if (!validateFn(newValue)) {
            setDisplayValue(formatPhoneDefault(newValue));
        }
        if (onBlur) {
            onBlur(e);
        }
    };
    const combinedOnChange = (e) => {
        field.onChange(e);
        const newValue = e.target.value;
        setDisplayValue(newValue);
        if (!validateFn(newValue)) {
            helpers.setValue(newValue ? formatPhoneHyphen(newValue) : null);
        }
        if (onChange) {
            onChange(e);
        }
    };
    const errorMessage = meta.touched ? meta.error : '';
    return (React.createElement(Box, { className: className },
        React.createElement(FormText, Object.assign({ labelContent: label, variant: "input", autoComplete: "tel-national", isPrivate: true, errorNotification: { message: errorMessage }, id: name, inputType: "tel", name: name, onBlur: combinedOnBlur, onChange: combinedOnChange, ref: refValue, required: required, value: displayValue }, props))));
};
export default PhoneNumber;
//# sourceMappingURL=PhoneNumber.js.map